/* Mobile menu – glass design (Matias Moellenbach) */
(function () {
  if (customElements.get('mm-mobile-menu')) return;

  class MMMobileMenu extends HTMLElement {
    connectedCallback() {
      this.tabsEl = this.querySelector('.mm-tabs');
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('.mm-tab'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('.mm-panel'));
      this.spacer = this.querySelector('.mm-tabs__spacer');
      this.details = this.closest('details');
      this.drawer = this.closest('header-drawer');
      this.selected = parseInt(this.dataset.selected || '0', 10) || 0;
      this.scrollTimer = null;
      this.programmatic = false;
      this.touching = false;
      this.section = this.closest('.shopify-section-header') || this.closest('.shopify-section');
      this.headerWrapper = this.closest('.header-wrapper');
      if (this.section) this.section.classList.add('mm-glass');

      this.onScroll = this.onScroll.bind(this);
      this.onToggle = this.onToggle.bind(this);
      this.onResize = this.onResize.bind(this);

      if (this.tabsEl) {
        this.tabsEl.addEventListener('scroll', this.onScroll, { passive: true });
        if ('onscrollend' in window) {
          this.tabsEl.addEventListener('scrollend', function () {
            if (this.programmatic) {
              this.programmatic = false;
              return;
            }
            this.onScrollEnd();
          }.bind(this));
        }
        this.tabsEl.addEventListener('touchstart', function () { this.touching = true; }.bind(this), { passive: true });
        this.tabsEl.addEventListener('touchend', function () { this.touching = false; }.bind(this), { passive: true });
        this.tabsEl.addEventListener('touchcancel', function () { this.touching = false; }.bind(this), { passive: true });

        // Re-align when the titles change size (e.g. when the font finishes loading).
        if (window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(function () {
            if (this.details && this.details.open && !this.touching) this.realign();
          }.bind(this));
          this.tabs.forEach(function (tab) { this.resizeObserver.observe(tab); }, this);
        }
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(function () {
            if (this.details && this.details.open && !this.touching) this.realign();
          }.bind(this));
        }

        this.tabs.forEach(function (tab, i) {
          tab.addEventListener('click', function (event) {
            event.preventDefault();
            this.select(i, { scroll: true, focus: false });
          }.bind(this));
          tab.addEventListener('keydown', this.onTabKeydown.bind(this));
        }, this);

        this.setupSwipe();
      }

      this.setupSearch();

      if (this.details) {
        this.details.addEventListener('toggle', this.onToggle);
        // mirror the theme's open / close state on the header section
        this.stateObserver = new MutationObserver(this.syncOpenState.bind(this));
        this.stateObserver.observe(this.details, { attributes: true, attributeFilter: ['class', 'open'] });
        this.syncOpenState();
      }
      window.addEventListener('resize', this.onResize);

      var close = this.querySelector('[data-mm-close]');
      if (close) {
        close.addEventListener('click', this.closeMenu.bind(this));
        close.addEventListener('keydown', function (event) {
          if (event.key === ' ' || event.key === 'Spacebar') this.closeMenu(event);
        }.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.details) this.details.removeEventListener('toggle', this.onToggle);
      window.removeEventListener('resize', this.onResize);
      if (this.stateObserver) this.stateObserver.disconnect();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.section) this.section.classList.remove('mm-glass', 'mm-menu-open');
    }

    syncOpenState() {
      if (!this.section || !this.details) return;
      var on = this.details.hasAttribute('open') && this.details.classList.contains('menu-opening');
      if (on) {
        this.setGlassHeight();
        this.measureTopBar();
      }
      this.section.classList.toggle('mm-menu-open', on);

      // closing: drop the keyboard and clear the search once the fade is done
      if (this.wasOpen && !on && this.searchInput) {
        this.searchInput.blur();
        clearTimeout(this.resetTimer);
        this.resetTimer = setTimeout(this.resetSearch.bind(this), 450);
      }
      this.wasOpen = on;
    }

    // Places the search field in the top bar, between the left edge and the cart.
    measureTopBar() {
      if (!this.headerWrapper) return;
      var hw = this.headerWrapper.getBoundingClientRect();
      var me = this.getBoundingClientRect();
      var h = me.top - hw.top;
      if (h > 0) this.style.setProperty('--mm-header-h', h + 'px');
      var cart = this.headerWrapper.querySelector('.header__cart');
      var cr = cart ? cart.getBoundingClientRect() : null;
      if (cr && cr.width) {
        this.style.setProperty('--mm-search-right', Math.max(0, Math.round(me.right - cr.left + 8)) + 'px');
      }
    }

    // The glass layer starts at the top bar and runs to the bottom of the screen.
    setGlassHeight() {
      if (!this.headerWrapper) return;
      var top = this.headerWrapper.getBoundingClientRect().top;
      var h = Math.max(window.innerHeight, document.documentElement.clientHeight) - top + 120;
      this.headerWrapper.style.setProperty('--mm-glass-h', Math.ceil(h) + 'px');
    }

    realign() {
      if (!this.tabsEl) return;
      var self = this;
      this.sizeSpacer();
      this.programmatic = true;
      this.tabsEl.scrollLeft = this.targetLeft(this.selected);
      this.markTabs(this.selected);
      clearTimeout(this.realignTimer);
      this.realignTimer = setTimeout(function () { self.programmatic = false; }, 60);
    }

    /* ---- layout ---- */
    gutter() {
      if (!this.tabsEl) return 0;
      return parseFloat(getComputedStyle(this.tabsEl).scrollPaddingInlineStart) ||
        parseFloat(getComputedStyle(this.tabsEl).paddingLeft) || 0;
    }

    // Lets the last title scroll all the way to the left edge.
    sizeSpacer() {
      if (!this.tabsEl || !this.spacer || !this.tabs.length) return;
      this.spacer.style.width = '0px';
      var last = this.tabs[this.tabs.length - 1];
      var needed = last.offsetLeft - this.gutter() + this.tabsEl.clientWidth - this.tabsEl.scrollWidth;
      this.spacer.style.width = Math.max(0, Math.ceil(needed)) + 'px';
    }

    targetLeft(i) {
      var tab = this.tabs[i];
      return tab ? Math.max(0, tab.offsetLeft - this.gutter()) : 0;
    }

    nearestIndex() {
      var left = this.tabsEl.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < this.tabs.length; i++) {
        var d = Math.abs(this.targetLeft(i) - left);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      }
      return best;
    }

    /* ---- events ---- */
    onToggle() {
      if (!this.details.open) return;
      var self = this;
      requestAnimationFrame(function () {
        self.measureTopBar();
        self.realign();
      });
    }

    onResize() {
      if (!this.details || !this.details.open) return;
      this.setGlassHeight();
      this.measureTopBar();
      if (!this.touching) this.realign();
    }

    onScroll() {
      if (this.programmatic) return;
      var i = this.nearestIndex();
      this.markTabs(i);
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(this.onScrollEnd.bind(this), 140);
    }

    onScrollEnd() {
      if (this.programmatic || this.dragging) return;
      clearTimeout(this.scrollTimer);
      var i = this.nearestIndex();
      if (i !== this.selected) this.select(i, { scroll: false });
    }

    onTabKeydown(event) {
      var i = this.tabs.indexOf(event.currentTarget);
      var next = null;
      if (event.key === 'ArrowRight') next = Math.min(this.tabs.length - 1, i + 1);
      if (event.key === 'ArrowLeft') next = Math.max(0, i - 1);
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.tabs.length - 1;
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.select(i, { scroll: true });
        return;
      }
      if (next === null) return;
      event.preventDefault();
      this.select(next, { scroll: true, focus: true });
    }

    /* ---- swipe left / right anywhere in the Type area ---- */
    setupSwipe() {
      this.swipeArea = this.querySelector('.mm-type');
      this.dragging = false;
      this.drag = null;
      if (!this.swipeArea || this.tabs.length < 2) return;
      this.swipeArea.addEventListener('touchstart', this.onSwipeStart.bind(this), { passive: true });
      this.swipeArea.addEventListener('touchmove', this.onSwipeMove.bind(this), { passive: false });
      this.swipeArea.addEventListener('touchend', this.onSwipeEnd.bind(this), { passive: true });
      this.swipeArea.addEventListener('touchcancel', this.onSwipeEnd.bind(this), { passive: true });
      // a swipe must never also open the link it started on
      this.swipeArea.addEventListener('click', function (event) {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      }.bind(this), true);
    }

    onSwipeStart(event) {
      this.suppressClick = false;
      // the title row scrolls on its own
      if (event.touches.length !== 1 || event.target.closest('.mm-tabs')) {
        this.drag = null;
        return;
      }
      var t = event.touches[0];
      var now = Date.now();
      this.drag = {
        x: t.clientX,
        y: t.clientY,
        lastX: t.clientX,
        lastT: now,
        vx: 0,
        dx: 0,
        axis: null,
        start: this.tabsEl.scrollLeft,
        index: this.selected
      };
    }

    onSwipeMove(event) {
      var d = this.drag;
      if (!d) return;
      var t = event.touches[0];
      var dx = t.clientX - d.x;
      var dy = t.clientY - d.y;

      if (!d.axis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        d.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (d.axis === 'x') this.beginDrag(d);
      }
      if (d.axis !== 'x') return;
      if (event.cancelable) event.preventDefault();

      var now = Date.now();
      var dt = Math.max(1, now - d.lastT);
      d.vx = 0.7 * ((t.clientX - d.lastX) / dt) + 0.3 * d.vx;
      d.lastX = t.clientX;
      d.lastT = now;
      d.dx = dx;

      // the titles follow the finger
      var max = this.targetLeft(this.tabs.length - 1);
      this.tabsEl.scrollLeft = Math.max(0, Math.min(max, d.start - dx));

      // the list moves a little with it (with resistance at the first / last type)
      var atEdge = (dx > 0 && d.index === 0) || (dx < 0 && d.index === this.tabs.length - 1);
      var panel = this.panels[d.index];
      if (panel) {
        panel.style.transform = 'translateX(' + (dx * (atEdge ? 0.12 : 0.3)) + 'px)';
        panel.style.opacity = String(Math.max(0.3, 1 - Math.abs(dx) / (atEdge ? 900 : 300)));
      }
    }

    beginDrag(d) {
      this.dragging = true;
      this.touching = true;
      this.suppressClick = true;
      clearTimeout(this.snapTimer);
      this.tabsEl.style.scrollSnapType = 'none';
      this.sizeSpacer();
      var panel = this.panels[d.index];
      if (panel) panel.style.transition = 'none';
    }

    onSwipeEnd() {
      var d = this.drag;
      this.drag = null;
      if (!d || d.axis !== 'x') return;

      var last = this.tabs.length - 1;
      var target = this.nearestIndex();
      var flick = Math.abs(d.vx) > 0.3 || Math.abs(d.dx) > 50;
      if (target === d.index && flick) target = d.index + (d.dx < 0 ? 1 : -1);
      target = Math.max(0, Math.min(last, target));

      var panel = this.panels[d.index];
      if (panel) {
        panel.style.transition = 'transform 0.45s cubic-bezier(0.22, 0.61, 0.36, 1), opacity 0.3s ease, visibility 0s linear 0.3s';
        panel.style.transform = '';
        panel.style.opacity = '';
        setTimeout(function () { panel.style.transition = ''; }, 500);
      }

      this.dragging = false;
      this.touching = false;
      this.select(target, { scroll: true });

      var self = this;
      clearTimeout(this.snapTimer);
      this.snapTimer = setTimeout(function () { self.tabsEl.style.scrollSnapType = ''; }, 650);
    }

    /* ---- search ---- */
    setupSearch() {
      this.searchForm = this.querySelector('.mm-search');
      this.searchInput = this.querySelector('.mm-search__input');
      this.resultsEl = this.querySelector('.mm-results');
      if (!this.searchForm || !this.searchInput || !this.resultsEl) return;
      this.searchCache = {};
      this.searchInput.addEventListener('input', this.onSearchInput.bind(this));
      this.searchForm.addEventListener('submit', function (event) {
        if (!this.searchInput.value.trim()) event.preventDefault();
      }.bind(this));
    }

    onSearchInput() {
      var q = this.searchInput.value.trim();
      var self = this;
      this.classList.toggle('is-searching', q.length > 0);
      clearTimeout(this.searchTimer);
      if (!q) {
        if (this.searchAbort) this.searchAbort.abort();
        this.resultsEl.classList.remove('is-loading');
        // empty the results after they have faded out
        clearTimeout(this.clearTimer);
        this.clearTimer = setTimeout(function () {
          if (!self.classList.contains('is-searching')) self.resultsEl.textContent = '';
        }, 300);
        return;
      }
      this.searchTimer = setTimeout(function () { self.runSearch(q); }, 180);
    }

    runSearch(q) {
      var key = q.toLowerCase();
      if (this.searchCache[key]) {
        this.renderResults(q, this.searchCache[key]);
        return;
      }
      if (this.searchAbort) this.searchAbort.abort();
      var controller = window.AbortController ? new AbortController() : null;
      this.searchAbort = controller;
      this.resultsEl.classList.add('is-loading');

      var url = (this.dataset.suggestUrl || '/search/suggest.json') +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';
      var self = this;
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (response) { return response.json(); })
        .then(function (data) {
          self.searchCache[key] = data;
          if (self.searchInput.value.trim() === q) self.renderResults(q, data);
        })
        .catch(function () {})
        .then(function () {
          if (self.searchAbort === controller) self.resultsEl.classList.remove('is-loading');
        });
    }

    renderResults(q, data) {
      var results = (data && data.resources && data.resources.results) || {};
      var products = results.products || [];
      var collections = results.collections || [];
      var pages = results.pages || [];
      var self = this;
      var i = 0;
      var inner = document.createElement('div');
      inner.className = 'mm-results__inner';
      // only the first set of results animates in; later keystrokes update quietly
      if (this.resultsEl.firstChild) inner.className += ' is-update';

      function el(tag, cls, text) {
        var n = document.createElement(tag);
        if (cls) n.className = cls;
        if (text !== undefined && text !== null) n.textContent = text;
        return n;
      }
      function stagger(n) {
        n.setAttribute('data-mm-r', '');
        n.style.setProperty('--i', String(i++));
        return n;
      }
      function textLink(item) {
        var a = el('a', 'mm-result mm-result--text');
        a.href = item.url;
        a.appendChild(el('span', 'mm-result__title', item.title));
        return a;
      }
      function productLink(p) {
        var a = el('a', 'mm-result');
        a.href = p.url;
        var media = el('span', 'mm-result__media');
        var src = (p.featured_image && p.featured_image.url) || p.image;
        if (src) {
          var img = document.createElement('img');
          img.src = self.sizedImage(src, 120);
          img.alt = '';
          img.width = 44;
          img.height = 54;
          media.appendChild(img);
        }
        var text = el('span', 'mm-result__text');
        text.appendChild(el('span', 'mm-result__title', p.title));
        var price = self.formatPrice(p.price_min || p.price);
        if (price) text.appendChild(el('span', 'mm-result__meta', price));
        a.appendChild(media);
        a.appendChild(text);
        return a;
      }
      function group(label, items, build) {
        if (!items.length) return;
        inner.appendChild(stagger(el('p', 'mm-label', label)));
        var ul = el('ul', 'mm-results__list');
        ul.setAttribute('role', 'list');
        items.forEach(function (item) {
          var li = stagger(el('li'));
          li.appendChild(build(item));
          ul.appendChild(li);
        });
        inner.appendChild(ul);
      }

      group('Products', products, productLink);
      group('Collections', collections, textLink);
      group('Pages', pages, textLink);

      if (!products.length && !collections.length && !pages.length) {
        inner.appendChild(stagger(el('p', 'mm-results__empty', 'No results for “' + q + '”')));
      }

      var all = stagger(el('a', 'mm-results__all', 'View all results'));
      all.href = (this.dataset.searchUrl || '/search') + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      inner.appendChild(all);

      this.resultsEl.classList.remove('is-loading');
      this.resultsEl.textContent = '';
      this.resultsEl.appendChild(inner);
    }

    sizedImage(src, width) {
      return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    formatPrice(value) {
      var n = parseFloat(value);
      if (isNaN(n)) return '';
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
      var amount;
      try {
        amount = new Intl.NumberFormat('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
      } catch (e) {
        amount = n.toFixed(2).replace('.', ',');
      }
      return amount + (currency ? ' ' + currency : '');
    }

    resetSearch() {
      if (!this.searchInput || (this.details && this.details.classList.contains('menu-opening'))) return;
      clearTimeout(this.searchTimer);
      if (this.searchAbort) this.searchAbort.abort();
      this.searchInput.value = '';
      this.classList.remove('is-searching');
      this.resultsEl.classList.remove('is-loading');
      this.resultsEl.textContent = '';
    }

    /* ---- state ---- */
    markTabs(index) {
      this.tabs.forEach(function (tab, i) {
        tab.classList.toggle('is-active', i === index);
      });
    }

    select(index, opts) {
      opts = opts || {};
      var self = this;
      this.selected = index;
      this.markTabs(index);

      this.tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });

      this.panels.forEach(function (panel, i) {
        var on = i === index;
        if (on && !panel.classList.contains('is-active')) {
          // restart the item animation
          panel.classList.remove('is-active');
          void panel.offsetWidth;
        }
        panel.classList.toggle('is-active', on);
      });

      if (opts.focus && this.tabs[index]) this.tabs[index].focus({ preventScroll: true });

      if (opts.scroll && this.tabsEl) {
        this.programmatic = true;
        var left = this.targetLeft(index);
        try {
          this.tabsEl.scrollTo({ left: left, behavior: 'smooth' });
        } catch (e) {
          this.tabsEl.scrollLeft = left;
        }
        clearTimeout(this.programmaticTimer);
        this.programmaticTimer = setTimeout(function () { self.programmatic = false; }, 700);
      }
    }

    closeMenu(event) {
      if (event) event.preventDefault();
      if (this.drawer && typeof this.drawer.closeMenuDrawer === 'function') {
        var summary = this.details ? this.details.querySelector('summary') : null;
        this.drawer.closeMenuDrawer(event || true, summary);
      } else if (this.details) {
        this.details.removeAttribute('open');
      }
    }
  }

  customElements.define('mm-mobile-menu', MMMobileMenu);
})();
